<script lang="ts">
  import clsx from 'clsx';

  const { sizeClass = 'w-full h-full' }: { sizeClass?: string } = $props();
</script>

<svg
  width="900"
  height="900"
  viewBox="0 0 900 900"
  fill="currentColor"
  class={clsx(sizeClass, 'overflow-hidden align-middle')}
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M900 350V850C900 863.261 894.732 875.979 885.355 885.355C875.979 894.732 863.261 900 850 900H350C336.739 900 324.021 894.732 314.645 885.355C305.268 875.979 300 863.261 300 850V350C300 336.739 305.268 324.021 314.645 314.645C324.021 305.268 336.739 300 350 300H850C863.261 300 875.979 305.268 885.355 314.645C894.732 324.021 900 336.739 900 350ZM150 550H100V100H550V150C550 163.261 555.268 175.979 564.645 185.355C574.021 194.732 586.739 200 600 200C613.261 200 625.979 194.732 635.355 185.355C644.732 175.979 650 163.261 650 150V50C650 36.7392 644.732 24.0215 635.355 14.6447C625.979 5.26784 613.261 0 600 0H50C36.7392 0 24.0215 5.26784 14.6447 14.6447C5.26784 24.0215 0 36.7392 0 50V600C0 613.261 5.26784 625.979 14.6447 635.355C24.0215 644.732 36.7392 650 50 650H150C163.261 650 175.979 644.732 185.355 635.355C194.732 625.979 200 613.261 200 600C200 586.739 194.732 574.021 185.355 564.645C175.979 555.268 163.261 550 150 550Z"
  />
</svg>
